"use client"

import { UnsupportBrowser } from '@/components/site/UnsupportBrowser';
import { BrowserCompatibilityTip } from '@/components/site/SiteBrowserTip';
import { useBrowserCompatibility } from '@/hooks/useBrowser';

export const BrowserDetect = ({ children }: React.PropsWithChildren) => {
  const compatibility = useBrowserCompatibility();
  if (compatibility === 'unsupported') {
    return <UnsupportBrowser />;
  }
  return (
    <>
      {compatibility === 'unknown' && <BrowserCompatibilityTip status={compatibility} />}
      {children}
    </>
  );
};
